import { render, staticRenderFns } from "./RBVPTextTab.vue?vue&type=template&id=04702a45"
import script from "./RBVPTextTab.vue?vue&type=script&lang=ts"
export * from "./RBVPTextTab.vue?vue&type=script&lang=ts"
import style0 from "./RBVPTextTab.vue?vue&type=style&index=0&id=04702a45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@babel+core@7.22.10_css-loader@5.2.7_webpack@5.97.1__lodash@4.17.21_prettier@2.8.8_webpack@5.97.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports